export default __webpack_public_path__ + "static/media/gallery_07.747e2b31.jpg";